import { Colors } from "../../Colors";

export const tableHeadCellSx = {
  borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
  color: Colors.info,
  fontSize: "0.75rem",
  fontWeight: 600,
  textTransform: "uppercase" as const,
  letterSpacing: "0.5px",
  py: 2,
};

export const bodyCellSx = {
  borderBottom: "1px solid rgba(255, 255, 255, 0.04)",
  color: "#FFF",
  fontSize: "0.813rem",
};

export const sectionCardSx = {
  backgroundColor: "rgba(255, 255, 255, 0.02)",
  border: "1px solid rgba(255, 255, 255, 0.08)",
  borderRadius: "12px",
  boxShadow: "none",
  overflow: "hidden",
};
